import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const script = this.el.querySelector('script')
        if(script) {
            const newScript = document.createElement('script')
            newScript.textContent = script.textContent;
            script.remove();
            this.el.appendChild(newScript);
        }
    }

    toggle(e) {
        if(e.target != this.el) return;

        if(e.way === "enter") {
            if(this.el.paused) {
                this.timeout = setTimeout(() => {
                    this.el.play()
                }, 200);
            }
        } else {
            if(!this.el.paused) {
                clearTimeout(this.timeout)
                this.el.pause()
            }
        }
    }
}
